// manifest file for financial claims

import { CircleDollarSign } from "lucide-react";

const manifest = {
  key: "financial_claims_management",
  isFreeModule: true,
  isPurchasable: false,
  icon: CircleDollarSign,
  names: {
    plan: {
      en: "Financial Claims Management",
      ar: "\u0625\u062f\u0627\u0631\u0629 \u0627\u0644\u0645\u0637\u0627\u0644\u0628\u0627\u062a \u0627\u0644\u0645\u0627\u0644\u064a\u0629",
      "zh-Hans": "财务索赔管理",
    },
    dashboard: {
      en: "Financial Claims Management",
      ar: "\u0625\u062f\u0627\u0631\u0629 \u0627\u0644\u0645\u0637\u0627\u0644\u0628\u0627\u062a \u0627\u0644\u0645\u0627\u0644\u064a\u0629",
      "zh-Hans": "财务索赔仪表板",
    },
  },
  defaultPath: "/financial-claims-dashboard",
  matchers: [
    /^\/financial-claims-dashboard(?:\/|$)/,
    /^\/financial-claims(?:\/|$)/,
    /^\/incoming-financial-claims(?:\/|$)/,
    /^\/financial-claims\/bank-accounts(?:\/|$)/,
    /^\/financial-claims\/new(?:\/|$)/,
    /^\/financial-claims\/contracts\/incoming(?:\/|$)/,
    /^\/financial-claims\/contracts\/approved(?:\/|$)/,
    /^\/financial-claims\/contracts\/[^/]+(?:\/|$)/,
  ],
  buildNavbarMenus: ({ t, activeModuleLabel }) => [
    {
      label: activeModuleLabel,
      path: "__financial_claims__",
      children: [
        { label: t("dashboard"), path: "/financial-claims-dashboard" },
        {
          label: t("menu_create_new_claim") || "Create New Claim",
          path: "/financial-claims/new",
          permissions: ["create_financial_claim"],
        },
        {
          label:
            t("menu_bank_account_management") || "Bank Account Management",
          path: "/financial-claims/bank-accounts",
          permissions: ["bank_account_management"],
        },
        {
          label: t("menu_my_financial_claims") || "My Financial Claims",
          path: "/financial-claims",
          // Other /financial-claims/* pages belong to their own links, so only highlight this exact page.
          exact: true,
          permissions: ["view_financial_claims"],
        },
        {
          label:
            t("menu_incoming_financial_claims") || "Incoming Financial Claims",
          path: "/incoming-financial-claims",
          permissions: [
            "review_financial_claim",
            "review_certificate_completion",
            "approve_claim_amount",
            "approve_claim_payment_processing",
            "approve_claim_payment",
          ],
        },
        {
          label: t("menu_contracts") || "Contracts",
          path: "__financial_claims_contracts_submenu__",
          children: [
            {
              label: t("contracts_incoming_page_title") || "Incoming Contracts",
              path: "/financial-claims/contracts/incoming",
              permissions: ["review_incoming_contract"],
            },
            {
              label: t("menu_approved_contracts") || "Approved Contracts",
              path: "/financial-claims/contracts/approved",
              permissions: ["view_approved_contracts"],
            },
          ],
        },
      ],
    },
  ],
};

export default manifest;
